<template>
  <div>
    <SOModalExport
      :is-running="isExporting"
      :context="'Penghapusan'"
      :total-data="`${countData} Nota Penghapusan`"
      :export-data-exist="exportData.length > 0 ? exportData.filter((v) => v.downloaded === false).length : 0"
      @close="closeModal"
      @do-export="doExport"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import SOModalExport from "@/so-components/global/modal/SOModalExport";

import { moduleName } from "../store/state";

export default {
  name: "SOExportModal",
  components: {
    SOModalExport,
  },
  computed: {
    ...mapGetters(moduleName, {
      isExporting: "exporting",
      countData: "countData",
      exportData: "exportData",
    }),
  },
  methods: {
    ...mapActions({
      toggleExporting: `${moduleName}/toggleExporting`,
      doExportData: `${moduleName}/exportData`,
    }),
    closeModal() {
      this.$router.back();
    },
    async doExport() {
      await this.closeModal();
      await this.toggleExporting(true);
      await this.doExportData();
    },
  },
};
</script>
